define(["require", "exports", "jquery", "knockout", "../../utils/kendoUtils", "../../utils/dateUtils", "../../utils/tools", "../../models/UserContext", "../../models/RecurringProfileModel", "../../models/RecurringCalcModel"], function (require, exports, $, ko, KendoUtils, DateUtils, tools, UserContext, RecurringProfileModel, RecurringCalcModel) {
    "use strict";
    var CustomerRecurringProfiles = /** @class */ (function () {
        function CustomerRecurringProfiles(customerId, lookupLists, initCallback) {
            this.userCanViewCustomerRecurringProfiles = ko.observable(UserContext.hasAccess("Admin,CustomerRecurringProfiles.View,CustomerRecurringProfiles.Edit,CustomerRecurringProfiles.Delete"));
            this.userCanEditCustomerRecurringProfiles = ko.observable(UserContext.hasAccess("Admin,CustomerRecurringProfiles.Edit,CustomerRecurringProfiles.Delete"));
            this.userCanDeleteCustomerRecurringProfiles = ko.observable(UserContext.hasAccess("Admin,CustomerRecurringProfiles.Delete"));
            this.userCanExportCustomerRecurringProfiles = ko.observable(UserContext.hasAccess("Admin,CustomerRecurringProfiles.Export"));
            this.customerId = ko.observable(0);
            this.recurringCalcModel = ko.observable(new RecurringCalcModel());
            this.editEditRecurringModel = ko.observable(new RecurringProfileModel());
            var self = this;
            self.customerId(customerId);
            self.lookupLists = lookupLists;
            self.customerRecurringInvoicesGridStructure = lookupLists.GridStructures.RecurringInvoicesStructure;
            if (this.userCanViewCustomerRecurringProfiles()) {
                self.initExportDataSource();
                if (initCallback) {
                    initCallback(self);
                }
            }
        }
        CustomerRecurringProfiles.prototype.initGrid = function () {
            if (this.userCanViewCustomerRecurringProfiles()) {
                this.initRecurringInvoicesTable();
            }
        };
        CustomerRecurringProfiles.prototype.initExportDataSource = function () {
            var self = this;
            self.customerRecurringInvoicesDataSourceOptions = {
                transport: {
                    read: {
                        url: "/CustomerRecurringProfiles/GetRecurringInvoices",
                        type: "POST",
                        data: function () {
                            var data = {};
                            data.customerId = self.customerId();
                            return data;
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.customerRecurringInvoicesGridStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.customerRecurringInvoicesDataSource = new kendo.data.DataSource(self.customerRecurringInvoicesDataSourceOptions);
        };
        CustomerRecurringProfiles.prototype.refresh = function () {
            var _a;
            (_a = this.customerRecurringInvoicesTable) === null || _a === void 0 ? void 0 : _a.refresh();
        };
        CustomerRecurringProfiles.prototype.initRecurringInvoicesTable = function () {
            var self = this;
            var columns = self.customerRecurringInvoicesGridStructure.columns;
            var gridId = "divRecurringInvoicesTable";
            var isAdmin = UserContext.hasAccess("Admin") && UserContext.currentUser().userName.indexOf("dstaigys") > -1;
            columns.push({
                field: "",
                title: "",
                width: isAdmin ? "140px" : "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEditCustomerRecurringProfiles()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit" title="Edit Recurring Taxes"></i>&nbsp;Edit 1</a>';
                        html += '&nbsp;<a class="btn btn-sm btn-info btn-sync" href="#"><i class="fa fa-refresh" title="Update Recurring Tax Line Items"></i>&nbsp;</a>';
                    }
                    if (isAdmin) {
                        html += '&nbsp;<a class="btn btn-sm btn-danger btn-admin" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    return html;
                }
            });
            self.customerRecurringInvoicesTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: self.customerRecurringInvoicesDataSourceOptions,
                gridOptions: {
                    //toolbar: kendo.template($('#bill-lines-toolbar-template').html()),
                    columns: columns,
                    resizable: true,
                    sortable: false,
                    reorderable: true,
                    columnMenu: true,
                    detailInit: self.recurringInvoicesDetailInit.bind(self)
                },
                enableExport: {
                    entityName: "RecurringInvoice",
                    title: "Recurring Invoices",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: gridId,
                showPagerOnTop: false
            };
            self.customerRecurringInvoicesTable.initGrid(gridOptions);
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                var editRecurringModel = new RecurringProfileModel();
                editRecurringModel.CustomerId(self.customerId());
                editRecurringModel.Id(data.Id);
                editRecurringModel.ExternalId(data.ExternalId);
                editRecurringModel.LocationId(data.LocationId);
                editRecurringModel.Tax1Name(data.Tax1Name);
                editRecurringModel.Tax2Name(data.Tax2Name);
                self.editRecurringLocation(editRecurringModel);
                event.preventDefault();
            }).on("click", ".btn-admin", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                var editRecurringModel = new RecurringProfileModel();
                editRecurringModel.CustomerId(self.customerId());
                editRecurringModel.Id(data.Id);
                editRecurringModel.ExternalId(data.ExternalId);
                editRecurringModel.LocationId(data.LocationId);
                editRecurringModel.Tax1Name(data.Tax1Name);
                editRecurringModel.Tax2Name(data.Tax2Name);
                self.openManualRecurringWindow(self.customerId(), data.NextInvoiceDate);
                event.preventDefault();
            }).on("click", ".btn-sync", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                tools.confirmModal({
                    title: "Update Recurring Profile Tax Line Items",
                    text: "Are you sure you want to Update Recurring Profile Tax Line Items?",
                    buttonTitle: "Update",
                    type: "info",
                    modalOptions: {},
                }, function (modal) {
                    $(modal).modal("hide");
                    tools.ajaxGet({
                        url: "/CustomerRecurringProfiles/UpdateRecurringProfileTaxes?recurringId=".concat(data.Id),
                    }).done(function (result) {
                        if (result.Success) {
                            tools.success("Changes updated successfully");
                            self.customerRecurringInvoicesTable.refresh();
                            return;
                        }
                    });
                });
                event.preventDefault();
            });
        };
        CustomerRecurringProfiles.prototype.recurringInvoicesDetailInit = function (e) {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.RecurringInvoiceItemsStructure;
            $("<div/>").appendTo(e.detailCell).kendoGrid({
                dataSource: {
                    data: e.data.Items,
                    serverPaging: false,
                    serverSorting: false,
                    serverFiltering: false,
                    pageSize: 10000,
                    schema: {
                        model: gridStructure.model
                    }
                },
                scrollable: false,
                resizable: true,
                sortable: true,
                pageable: true,
                columns: gridStructure.columns,
                dataBound: function (e) {
                }
            }).data("kendoGrid");
        };
        CustomerRecurringProfiles.prototype.openManualRecurringWindow = function (customerId, nextInvoiceDate) {
            var self = this;
            var title = "Manual CDR's calculations";
            tools.editModal({
                title: title,
                buttonTitle: "Run",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.runRecurringCalculations(event.currentTarget, modal);
                },
                opened: function (modal) {
                    self.recurringCalcModel().CustomerId(customerId);
                    self.recurringCalcModel().CalcDate(nextInvoiceDate);
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'recurring-calc-template', data: recurringCalcModel }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        CustomerRecurringProfiles.prototype.runRecurringCalculations = function (btn, modal) {
            var self = this;
            var obj = {};
            obj["calcDate"] = DateUtils.toIsoStringDate(self.recurringCalcModel().CalcDate());
            obj["customerId"] = self.recurringCalcModel().CustomerId();
            obj["updateRecurring"] = self.recurringCalcModel().UpdateRecurring();
            obj["sendEmail"] = self.recurringCalcModel().SendEmail();
            tools.ajaxGet({
                url: "/AdminActions/CalculateRecurringOnCycleEnd",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Calculations ran successfully");
                    self.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerRecurringProfiles.prototype.updateRecurringProfiles = function () {
            var self = this;
            tools.ajaxPost({
                url: "/Freshbooks/UpdateCustomerRecurringsPoNumber",
                data: { id: self.customerId() }
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.customerRecurringInvoicesTable.refresh();
                    return;
                }
            });
        };
        CustomerRecurringProfiles.prototype.editRecurringLocation = function (recurringModel) {
            var self = this;
            self.editEditRecurringModel(recurringModel);
            var title = "Edit Recurring " + recurringModel.ExternalId() + " Profile Location";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.saveRecurringLocation(event.currentTarget, modal);
                },
                opened: function (modal) {
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: "/CustomerRecurringProfiles/GetRecurringLookupData",
                        data: { customerId: recurringModel.CustomerId() },
                        success: function (data) {
                            if (data.Success) {
                                self.recurringLookupLists = data.Data.lookupLists;
                                self.recurringLookupLists.officeLocations = ko.observableArray(data.Data.lookupLists.OfficeLocations);
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'recurring-edit-template', data: editEditRecurringModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CustomerRecurringProfiles.prototype.saveRecurringLocation = function (btn, modal) {
            var self = this;
            var obj = {};
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            obj["recurringId"] = self.editEditRecurringModel().Id();
            obj["locationId"] = self.editEditRecurringModel().LocationId();
            obj["tax1Name"] = self.editEditRecurringModel().Tax1Name();
            obj["tax2Name"] = self.editEditRecurringModel().Tax2Name();
            tools.ajaxPost({
                url: "/CustomerRecurringProfiles/SaveRecurringLocation",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        return CustomerRecurringProfiles;
    }());
    return CustomerRecurringProfiles;
});
//# sourceMappingURL=customerRecurringProfiles.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerRecurringProfiles.js
// module id = 197
// module chunks = 2